import { useEffect, useState } from "react"

const useTextarea = (getData, questionNumber,data,operation) => {

    const [defaultQuestion, setDefaultQuestion] = useState(data?.question || "")
    const [defaultAnswer, setDefaultAnswer] = useState(data?.answer ||"")
    const [defaultDescription, setDefaultDescription] = useState(data?.description ||"")

    const [question, setQuestion] = useState(data?.question || "")
    const [answer, setAnswer] = useState(operation === "preview"?"":data?.answer ||"" )
    const [description, setDescription] = useState(data?.description ||"")

    const resetFields = () => { setQuestion(""); setAnswer(""); setDescription("") }
    const resetDefaultFields = () => { setQuestion(defaultQuestion); setAnswer(defaultAnswer); setDescription(defaultDescription) }

    const onChangequestion = (e) => { setQuestion(e.target.value) };
    const onChangeAnswer = (e) => { setAnswer(e.target.value) };
    const onChangeDescription = (e) => { setDescription(e.target.value) };


    useEffect(() => {
        getData(questionNumber, { question, answer, description })
    }, [question, answer, description])





    return {
        onChangequestion,
        onChangeAnswer,
        onChangeDescription,
        resetFields,
        question,
        answer,
        description,
        resetDefaultFields
    }
}
export default useTextarea